import { render, staticRenderFns } from "./ProjectLastVersionsDifferencesView.vue?vue&type=template&id=07776b8a&"
import script from "./ProjectLastVersionsDifferencesView.vue?vue&type=script&lang=js&"
export * from "./ProjectLastVersionsDifferencesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports